export default __webpack_public_path__ + "static/media/play-circle-filled.e52d7114.svg";